import { makeAutoObservable, runInAction } from "mobx";
import Subjects from "../../models/subjects";
import IStudent from "../../models/student";
import { message } from "antd";
import { StudentService } from "../../services/student-service";
import StudentItemStore from "./student-item";
import Pagination from "../../models/pagination";

export default class StudentList {

    data: StudentItemStore[];
    totalCount: number;
    subject: Subjects;
    currentPage: number;
    newStudentName: string;
    studentService: StudentService;
    loading: boolean;

    constructor(subject: Subjects) {

        this.data = [];
        this.totalCount = 0;
        this.subject = subject;
        this.currentPage = 0;
        this.newStudentName = "";
        this.loading = false;
        this.studentService = new StudentService(subject);

        makeAutoObservable(this);
    }

    loadList(page: number): void {

        try {
            this.currentPage = page;
            this.loading = true;
            var params = { 
                subject: this.subject, 
                page: (page - 1),//antd starts pagination from 1, Spring from 0 
                size: Pagination.PAGE_SIZE 
            };
            const urlParams = new URLSearchParams(JSON.parse(JSON.stringify(params)));

            this.studentService.loadList(
                urlParams,
                data => {
                    this.data = (data['content'] as IStudent[]).map((item) => new StudentItemStore(item, this.subject));
                    this.totalCount = data['totalElements'];
                    this.currentPage = page;
                    this.loading = false;
                }
            );

        } catch (error) {
            runInAction(() => { message.error(error); this.loading = false; });
        }
    }

    changeNewStudentName(name: string): void {
        this.newStudentName = name;
    }

    createStudent(): void {

        if (!this.newStudentName) {
            message.error("Введите имя ученика!");
        } else {

            try {
                this.studentService.createStudent(
                    this.newStudentName,
                    _ => {
                        this.loadList(this.currentPage);
                        this.newStudentName = "";
                    }
                );
            } catch (error) {
                runInAction(() => { message.error(error) });
            }
        }
    }
}